// extracted by mini-css-extract-plugin
module.exports = {"base":"Avatar_base__3VYzB","large":"Avatar_large__1s5GC","extra-large":"Avatar_extra-large__3C8qk"};